import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { ServiceAccount, ServiceAccountInput } from '@/models/serviceAccount';

export const createServiceAccount = async (data: ServiceAccountInput): Promise<ServiceAccount> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreateServiceAccount($data: ServiceAccountInputType!) {
        createServiceAccount(data: $data) {
          id
          user
          service
          email
          password
          phoneNumber
          isActive
          isClosed
          isAutomatedAccount
          isManualAccount
          createdAt
          updatedAt
        }
      }
    `),
    variables: {
      data,
    },
  });

  return response.data?.createServiceAccount!;
};
